/* eslint-disable no-restricted-imports */
import { useTranslation } from 'react-i18next'

export function useTranslations() {
    const { t } = useTranslation('BlurEffect')

    return t
}

export function useI18nInstance() {
    const { i18n } = useTranslation('BlurEffect')

    return i18n
}
